<template>
  <a-modal
    :title="title"
    style="top: 20px;"
    :width="800"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-row :gutter="8">
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="商品编号"
          >
            <a-input
              autocomplete="false"
              v-decorator="[
                  'locationNo',
                  {initialValue:formdata.locationNo, rules: [{ required: true, message: '请输入商品编号' }]}
                ]"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="商品名称"
          >
            <a-input
              autocomplete="false"
              v-decorator="[
                  'name',
                  {initialValue:formdata.name, rules: [{ required: true, message: '请输入商品名称' }]}
                ]"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="商品条码"
          >
            <a-input
              autocomplete="false"
              v-model="formdata.barCode"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="规格型号"
          >
            <a-input
              autocomplete="false"
              v-model="formdata.type"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="商品类别"
          >
            <a-tree-select
              placeholder='请选择商品类别'
              treeDefaultExpandAll
              :treeData="categoryData"
              v-model="formdata.catId"
            >
            </a-tree-select>
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="首选仓库"
          >

            <a-select v-model="formdata.defaultStoreId" allowClear placeholder="[ 空 ]" @change="storeChange">
              <a-select-option value="0">[ 空 ]</a-select-option>
              <a-select-option v-for="(item, index) in storeData" :value="item.id" :key="index"> {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="计量单位"
            required
          >

            <a-select v-model="formdata.unitId" allowClear placeholder="[ 空 ]" @change="unitChange">
              <a-select-option value="0">[ 空 ]</a-select-option>
              <a-select-option v-for="(item, index) in unitData" :value="item.id" :key="index"> {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-item
            :wrapperCol="{xs: { span: 24 },sm: { span: 24 }}"
          >
            <a-textarea
              placeholder="添加备注信息"
              :autosize="{ minRows: 2, maxRows: 6 }"
              v-model="formdata.note"
            />
          </a-form-item>
        </a-col>
      </a-row>

    </a-form>
  </a-modal>
</template>

<script>
import { getCategoryGoods } from '@/api/category'
import { getUnitList } from '@/api/unit'
import { commonStoreList } from '@/api/common'
import { STATUS_ACTIVE, CODE_FAIL } from '@/store/mutation-types'
import { editGoods, addGoods } from '@/api/goods'
export default {
  name: 'GoodsForm',
  props: {
    title: {
      type: String,
      default: '新增'
    },
    visible: {
      type: Boolean,
      default: false
    },
    isEditForm: {
      type: Boolean,
      default: false
    },
    formdata: {
      type: Object,
      default: () => ({
        locationNo: '',
        name: '',
        barCode: '',
        type: '',
        catId: '0',
        defaultStoreId: '0',
        unitId: '0',
        note: ''
      })
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      categoryData: null,
      unitData: null,
      storeData: null,
      form: this.$form.createForm(this, this.formdata)
    }
  },
  beforeCreate () {
  },
  created () {
    this.loadCategory()
    this.loadUnit()
    this.loadStore()
  },
  methods: {
    unitChange (val) {
      if (!val) {
        this.formdata.unitId = ''
      }

    },
    storeChange (val) {
      if (!val) {
        this.formdata.defaultStoreId = ''
      }
    },
    loadCategory () {
      getCategoryGoods({ tree: true })
        .then(res => {
          this.categoryData = res.result
        })
    },
    loadUnit () {
      getUnitList({ status: STATUS_ACTIVE })
        .then(res => {
          this.unitData = res.result.data
        })
    },
    loadStore () {
      commonStoreList({ status: STATUS_ACTIVE, all: true })
        .then(res => {
          this.storeData = res.result.data
        })
    },
    handleOk () {
      const vm = this
      this.form.validateFields((err, values) => {
        if (!err) {
          const datas = Object.assign({}, this.formdata, values)

          if (this.isEditForm) {
            editGoods(datas).then(res => {
              if (res.status !== CODE_FAIL) {
                this.$message.success('修改成功')
                this.form.resetFields()
                // this.form.resetFields()
                vm.$emit('formsuccess', datas)
              } else {
                this.$message.error(res.message)
              }
            })
          } else {
            addGoods(datas).then(res => {
              if (res.status !== CODE_FAIL) {
                this.$message.success('新增成功')
                this.form.resetFields()
                // this.form.resetFields()
                vm.$emit('formsuccess', datas)
              } else {
                this.$message.error(res.message)
              }
            })
          }
        }
        vm.$emit('formerror', err)
      })
    },
    handleCancel () {
      this.$emit('formcancel')
    }
  }
}
</script>
